<template>
  <div class="address-prove">
    <Progress progress="28"></Progress>
    <p class="title">{{ $t('openAccount.t000124') }}</p>
    <div class="sub-title-box">
      <p class="sub-title">
        {{ $t('openAccount.t000125') }}
      </p>
      <p class="sub-title">
        {{ $t('openAccount.t000126') }}
      </p>
    </div>
    <div class="upload-box">
      <UploadImg
        :icon="addressIcon"
        :img="form.address_img_base64"
        @afterRead="afterRead"
        @del="delImg"
        :quality="0.5"
        :text="$t('openAccount.t000127')"
      />
    </div>
    <div class="info-box">
      <div class="ipt-box" :class="{error: isClickNext && !form.nationality_or_region_name}">
        <div class="ipt-main">
          <div class="val-box" @click="checkCountryDialog">
            <span class="label" :class="{ placeholder: !form.nationality_or_region_name }"
            >{{ $t('openAccount.t000063') }}</span
            >
            <span class="val" v-if="form.nationality_or_region_name">{{
                form.nationality_or_region_name
              }}</span>
          </div>
          <span class="icon-arrow"></span>
        </div>
        <p class="error">{{ $t('openAccount.t000064') }}</p>
      </div>
      <div
        v-if="[1,2,'1','2'].includes(form.nationality_or_region_code)"
        :class="{ error: isClickNext && !form.province_name }"
        class="ipt-box"
      >
        <div class="ipt-main" :class="{onlyEn: form.nationality_or_region_code != 1}">
          <div class="val-box" @click="openAreaPopup">
            <span :class="{ placeholder: !form.province_name }" class="label"
              >{{ $t('openAccount.t000082') }}<span v-if="form.nationality_or_region_code != 1">({{$t('openAccount.t000128')}})</span></span
            >
            <span v-if="form.province_name" class="val">{{ getFullAddress() }}</span>
          </div>
          <span class="icon-arrow"></span>
        </div>
        <p class="error">{{ $t('openAccount.t000083') }}</p>
      </div>
      <div
        v-if="![1,2,'1','2'].includes(form.nationality_or_region_code)"
        :class="{ error: isClickNext && !form.otherAffiliation, focus: inputFocusId == 1 }"
        class="ipt-box"
      >
        <div class="ipt-main" :class="{onlyEn: form.nationality_or_region_code != 1}">
          <div class="val-box">
            <span class="label"
            >{{ $t('openAccount.t000082') }} <span v-if="form.nationality_or_region_code != 1">({{$t('openAccount.t000128')}})</span></span
            >
            <Field
              v-model="form.otherAffiliation"
              class="val"
              :placeholder="inputFocusId == 1 ? '' : $t('openAccount.t000174')"
              rows="2"
              type="textarea"
              :formatter="formatVal"
              @focus="inputFocus(1)"
              @blur="inputBlur"
            ></Field>
          </div>
        </div>
        <p class="error">{{ $t('openAccount.t000083') }}</p>
      </div>

      <div
        :class="{ error: isClickNext && !form.detail_address, focus: inputFocusId == 2  }"
        class="ipt-box"
      >
        <div class="ipt-main" :class="{onlyEn: form.nationality_or_region_code != 1}">
          <div class="val-box">
            <span class="label"
              >{{ $t('openAccount.t000084') }} <span v-if="form.nationality_or_region_code  != 1">({{$t('openAccount.t000128')}})</span></span
            >
            <Field
              v-model="form.detail_address"
              class="val"
              :formatter="formatVal"
              :placeholder="inputFocusId == 2 ? '' : $t('openAccount.t000175')"
              rows="2"
              type="textarea"
              @focus="inputFocus(2)"
              @blur="inputBlur"
            ></Field>
          </div>
        </div>
        <p class="error">{{ $t('openAccount.t000086') }}</p>
      </div>
    </div>
    <NavButtons @on-next="next" :next-text="$route.query.change == 1 ? $t('openAccount.t000094') : $t('openAccount.t000095')" />
    <!--    地址选择 省市县 -->
    <van-popup v-model="showAreaPopup" position="bottom" class="address-popup picker-ui">
      <van-area
        :value="form.country_code || form.city_code || form.province_code"
        :area-list="areaList"
        @cancel="showAreaPopup = false"
        @confirm="confirmArea"
      ></van-area>
    </van-popup>
    <!--    选择国籍弹窗 -->
    <van-popup
      v-model="checkCountryNameDialog"
      :showConfirmButton="false"
      class="check-country"
      :class="bgColor == 'black-theme' ? 'darkOrLight' : 'check-country'"
      getContainer="body"
      position="right"
    >
      <div class="dialog-head">
        <a class="btn-back" @click="checkCountryNameDialogBack"></a>
        <p class="dialog-title">{{$t('openAccount.t000096')}}</p>
      </div>
      <div class="input-box">
        <Field
          v-model="checkCountryKeyWord"
          left-icon="search"
          :placeholder="$t('openAccount.t000097')"
        ></Field>
      </div>
      <div class="list">
        <div class="list-main">
          <template v-for="item in countryNameList">
            <div
              v-if="
                !checkCountryKeyWord ||
                  item.name.indexOf(checkCountryKeyWord) >= 0
              "
              @click="checkCountry(item)"
              class="item"
              :class="{ cur: form.country_code == item.id }"
              :key="item.id"
            >
              <span>{{ item.name }}</span>
              <Icon
                v-show="form.country_code == item.id"
                name="success"
                color="#ff9275"
              />
            </div>
          </template>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Progress from "@/views/open-account/components/Progress.vue";
import UploadImg from "@/views/open-account/components/UploadImg.vue";
import addressIcon from "@/assets/images/id-card-upload-address.png";
import { Area, Field, Icon, Popup, Toast } from "vant";
import NavButtons from "@/views/open-account/components/navButtons.vue";
import JsBridge from "@/utils/jsBridge";
import { closeDialog, dialogStatus } from "@/utils/hybirdMethods";
import { getBrowser } from "@/utils/browser";

export default {
  name: "AddressProve",
  components: {
    Icon,
    NavButtons,
    Field,
    UploadImg,
    Progress,
    [Popup.name]: Popup,
    [Area.name]: Area
  },
  computed: {
    bgColor() {
      return this.$store.getters["common/bgColor"];
    }
  },
  data() {
    return {
      addressIcon,
      process_id: "",
      form: {
        address_img: "",
        address_img_base64: "",
        province_code: "",
        province_name: "",
        city_code: "",
        city_name: "",
        country_code: "",
        country_name: "",
        detail_address: "",
        otherAffiliation: '',
        nationality_or_region_name: '',
        nationality_or_region_code: ''
      },
      showAreaPopup: false, // 省市县选择
      areaList: [],
      isClickNext: false,
      isFromPrev: false,
      inputFocusId: null,
      checkCountryNameDialog: false,
      checkCountryKeyWord: "",  // 国籍搜索key
      countryNameList: [],
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    this.$JsBridge.registerHandler('closeDialog', () => {
      this.checkCountryNameDialog = false;
      dialogStatus({
        isShowing: false,
      })
    })
  },
  beforeRouteEnter(to, from, next){
    next(vm => {
      vm.isFromPrev = from.path == '/open-account/id-card-confirm'
    })
  },
  methods: {
    checkCountryDialog() {
      this.checkCountryNameDialog = true;
      if (getBrowser().isApp){
        dialogStatus({
          isShowing: true,
        })
      }
    },
    checkCountryNameDialogBack(){
      this.checkCountryNameDialog = false;
      if (getBrowser().isApp){
        dialogStatus({
          isShowing: false,
        })
      }
    },
    checkCountry(e) {
      this.form.otherAffiliation = ""
      this.form.nationality_or_region_code = e.id;
      this.form.nationality_or_region_name = e.name;
      if(e.id == 1){
        this.form.province_code = '110000';
        this.form.city_code = '110100';
        this.form.country_code = '110101';
        this.form.province_name = '';
        this.form.city_name = '';
        this.form.country_name = '';
      }
      else if(e.id == 2){
        this.form.province_code = '810000';
        this.form.province_name = 'HongKong';
        this.form.city_code = '810100';
        this.form.city_name = 'Hong Kong Island';
        this.form.country_code = '810101';
        this.form.country_name = 'Central and Western District';
      }
      this.checkCountryNameDialog = false;
      if(getBrowser().isApp){
        dialogStatus({
          isShowing: false,
        })
      }
    },
    inputFocus(id){
      this.inputFocusId = id;
    },
    inputBlur(){
      this.inputFocusId = null;
    },
    formatVal(e){
      if(this.form.nationality_or_region_code != 1){
        return e.replace(/[\u4e00-\u9fa5]/g, '');
      }else{
        return e;
      }
    },
    async getData() {
      this.countryNameList = await this.$apis.getAllCountryList();
      this.$apis.accountSituationV2({
        step_code: "1,3-2,4",
      }).then(res => {
        if (!res?.process_info) return;
        this.process_id = res?.process_info?.["1"]?.process_id || res?.get_open_account_info?.open_status;
        this.pageData = res?.process_info;
        // 如果不是大陆直接渲染第4步的数据
        
        if (this.process_id !== 1) {
          this.handleNonMainland(res);
          return;
        }
        // 如果3-2的数据为空直接渲染第4步的数据
        const config_data = res?.process_info?.["3-2"]?.config_data;
        if (!config_data || JSON.stringify(config_data) === "{}") {
          this.handleNonMainland(res);
          return;
        }
        // 如果没有勾选同步直接返回不渲染数据
        const parsedConfig = JSON.parse(config_data);
        // 
        if (!parsedConfig.oneAddress && !this.$route.query.change) return;
        // 如果被勾选了且是从身份认证过来的渲染3-2的数据
        if (this.isFromPrev) {
          const { positive_img, positive_img_base64, ...restParsedConfig } = parsedConfig;
          this.form = {
            ...this.form,
            ...restParsedConfig,
            address_img: positive_img,
            address_img_base64: positive_img_base64
          };
        } else {        // 大陆情况下返回上一步触发
          this.handleNonMainland(res);
        }
        if(this.form.nationality_or_region_code){
          this.form.nationality_or_region_name = this.countryNameList?.find(item => item.id == this.form.nationality_or_region_code)?.name;
        }else{
          this.form.nationality_or_region_code = parsedConfig.nationality_code
          this.form.nationality_or_region_name = parsedConfig.nationality_name
        }
      });
    },
    handleNonMainland(res) {
      
      if (res?.process_info?.["4"]?.config_data) {
        const data = JSON.parse(res?.process_info?.["4"]?.config_data);
        this.form = {
          ...this.form,
          ...data
        }
        // 如果是香港 归属地没填的时候 默认改为香港，用省没填来判断因为澳门没有市区
        if (!this.form.province_code) {
          this.form.country_code = "810101";
        }
        if(!this.form.nationality_or_region_code){
          const data_3_2 = res?.process_info?.["3-2"]?.config_data ? JSON.parse(res?.process_info?.["3-2"]?.config_data) : {};
          this.form.nationality_or_region_code = data_3_2.nationality_code
          this.form.nationality_or_region_name = data_3_2.nationality_name
        }
      }else{
        const data_3_2 = res?.process_info?.["3-2"]?.config_data ? JSON.parse(res?.process_info?.["3-2"]?.config_data) : {};
        this.form.nationality_or_region_code = data_3_2.nationality_code
        this.form.nationality_or_region_name = data_3_2.nationality_name
      }
      if(this.process_id == 2 && !res?.process_info?.["4"]?.config_data){
        // 如果是香港 归属地没填的时候 默认改为香港
        this.form.country_code = "810101";
      }
    },
    getFullAddress() {
      const { province_name, city_name, country_name } = this.form;
      return [province_name, city_name, country_name]
        .filter(name => name)
        .join("-");
    },
    openAreaPopup() {
      this.$apis.getAddressLists().then(res => {
        const lang = localStorage.getItem("localLang");
        let key = "en";
        if (lang && lang != "en") {
          key = "zh";
        }
        if(this.form.nationality_or_region_code  != 1){
          key = "en";
        }
        this.areaList = res[key];
        this.showAreaPopup = true;
      });
    },
    confirmArea(e) {
      
      this.form.province_code = e[0]?.code;
      this.form.province_name = e[0]?.name;
      this.form.city_code = e[1]?.code;
      this.form.city_name = e[1]?.name;
      this.form.country_code = e?.[2]?.code;
      this.form.country_name = e?.[2]?.name;
      this.showAreaPopup = false;
    },
    afterRead(res) {
      this.form.address_img = res.content;
      this.form.address_img_base64 = res.base64;
    },
    delImg() {
      this.form.address_img = "";
      this.form.address_img_base64 = "";
      // 通知服务端删除照片 不然下一次还是这个图的
      const params = {
        process_id: this.process_id,
        step_code: 4,
        step_order: "4",
        config_data: this.form
      };
      this.$apis.supplementSaveApi(params);
    },
    next() {
      this.isClickNext = true;
      if (!this.form.address_img) {
        Toast({
          message: this.$t('openAccount.t000129')
        });
        return;
      }
      let requiredKey = ["address_img", "province_name", "detail_address"]; // 不能为空的字段
      if (![1,2,'1','2'].includes(this.form.nationality_or_region_code)) {
        requiredKey = ["address_img", "detail_address", "otherAffiliation"];
      }
      // 校验必填字段
      let check = true;
      for (let i = 0; i < requiredKey.length; i++) {
        if (!this.form[requiredKey[i]]) {
          check = false;
          
        }
      }
      if (!check) return;
      // 香港 其他
      const loading = Toast.loading({
        // mask: true, //蒙层
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: this.$t("common.loading_text")
      });
      // if(!this.$route.query.change){
      //   const params32 = {
      //     process_id: this.process_id,
      //     step_code: '3-2',
      //     step_order: 3,
      //     config_data: {
      //       ...this.form,
      //       inverse_img_base64: '',
      //       positive_img_base64: '',
      //       address_img_base64: ''
      //     }
      //   };
      //   let config_data = this.pageData?.["3-2"]?.config_data;
      //   if(config_data){
      //     config_data = JSON.parse(config_data);
      //     params32.config_data = {
      //       ...config_data,
      //       ...this.form,
      //       inverse_img_base64: '',
      //       positive_img_base64: '',
      //       address_img_base64: ''
      //     }
      //   }
      //   this.$apis
      //     .supplementSaveApi(params32)
      // }


      const params = {
        process_id: this.process_id,
        step_code: 4,
        step_order: "4",
        config_data: {
          ...this.form,
          inverse_img_base64: '',
          positive_img_base64: '',
        },
        showLoading: true
      };
      this.$apis
        .supplementSaveApi(params)
        .then(res => {
          let path = "/open-account/personalInformation";
          if(this.$route.query.change == 1){
            path = "/open-account/home"
          }
          this.$router
            .push({
              path
            })
            .finally(() => {
              loading.clear();
            });
        })
        .catch(() => {
          loading.clear();
        });
      //
    }
  }
};
</script>

<style lang="less" scoped>
.address-prove {
  padding-top: 62px;
  padding-bottom: 180px;
  color: #17161c;
  box-sizing: border-box;
  min-height: 100%;
  .title {
    color: #17161c;
    font-size: 36px;
    font-weight: 500;
    line-height: 88px;
    padding: 14px 32px 0;
    border-bottom: #f3f3f3 solid 1px;
  }

  .sub-title-box {
    padding: 32px;
    font-size: 28px;
    line-height: 48px;
    color: #17161c;
  }

  .upload-box {
    padding: 0 32px;
    ::v-deep {
      .upload{
        padding: 40px 0;
      }
      .icon-box {
        width: 120px;
        height: 120px;
      }
    }
  }
  .info-box {
    margin-top: 24px;
    padding: 0 32px;
  }
  .ipt-box {
    margin-bottom: 24px;
    &.focus{
      .ipt-main{
        &:after{
          border-color: #17161C;
        }
        ::v-deep .van-cell{
          input {
            &::placeholder {
              font-size: 0;
            }
          }
        }
      }
    }
    &.error{
      .ipt-main {
        &:after {
          border-color: #FD2626;
        }
      }
    }
    .ipt-main {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px 32px;
      min-height: 56px;
      position: relative;
      &.onlyEn{
        .val-box .label span{
          display: block;
        }
        ::v-deep input,::v-deep  textarea {
          ime-mode:disabled;
        }
      }
      &:after{
        content: '';
        position: absolute;
        margin-top: -1px;
        top: -50%;
        left: -50%;
        width: 200%;
        height: 200%;
        border: 1px solid rgba(23, 22, 28, 0.25);
        transform: scale(0.5);
        border-radius: 20px;
      }
      .val-box {
        position: relative;
        z-index: 3;
        flex: 1;
        display: flex;
        flex-direction: column;
        line-height: 1;
        font-size: 32px;
        @keyframes labelAni{
          0%{
            font-size: 28px;
          }
          100%{
            font-size: 24px;
          }
        }
        .label {
          display: flex;
          color: #747377;
          padding: 4px 0 20px;
          font-size: 24px;
          transform: translate3d(0,0,0);
            animation: labelAni .2s .1s linear both;
          &.placeholder {
            padding: 12px 0 6px 0;
            font-size: 28px;
            animation: none;
          }
        }
        ::v-deep .van-cell {
          min-height: 0px;
          font-size: 32px;
          line-height: 32px;
          input{
            &::placeholder {
              font-size: 28px;
              color: #747377;
              font-weight: normal;
            }
            &:focus ~ .van-field__body{
              background: red;
            }
          }
          textarea {
            font-size: 32px;
            line-height: 40px;
            min-height: 80px;
            color: #17161c;
            font-weight: 500;
            &::placeholder {
              font-size: 28px;
            }
          }
        }
        .val {
          padding: 0;
          line-height: 36px;
          color: #17161c;
          font-weight: 500;
        }
      }
      .icon-arrow {
        width: 32px;
        height: 32px;
        background: url("../../../assets/images/arrow-down.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .error {
      display: none;
      margin-top: 12px;
      color: #fd2626;
      font-size: 24px;
      &.show{
        display: block;
      }
      &.right{
        text-align: right;
      }
    }
    &.error{
      .ipt-main{
        border-color: #fd2626;
      }
      .error{
        display: block;
      }
    }
  }
}
.address-popup{

  border-radius: 32px 32px 0 0;
  ::v-deep .van-picker{
    //border-radius: 32px 32px 0 0;
    .van-picker__toolbar{
      padding-top: 32px;
    }
  }
}
.check-country.darkOrLight{
  width: 100%;
  height: 100vh;
  border-radius: 0;
  z-index: 9999 !important;
  display: flex;
  flex-direction: column;
  background: #1B1C24;
  .dialog-head {
    height: 100px;
    display: flex;
    padding: 0 100px;
    position: relative;
    .btn-back {
      position: absolute;
      left: 0;
      top: 0;
      height: 100px;
      width: 100px;
      background: url("../../../assets/images/open-account/open-back.png") no-repeat center;
      background-size: 48px 48px;
      transform: rotateY(0deg);
    }
    .dialog-title {
      flex: 1;
      text-align: center;
      font-size: 32px;
      color: #FFFFFF;
      line-height: 100px;
    }
  }
  .input-box {
    padding: 0 32px;
    ::v-deep .van-cell {
      border-radius: 10px;
      background: #f7f8fa;
      min-height: 75px;
    }
  }
  .list {
    margin-top: 20px;
    flex: 1;
    position: relative;
    .list-main {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow-y: scroll;
      .item {
        line-height: 80px;
        padding: 0 32px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        font-size: 28px;
        color: #FFFFFF;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.cur {
          color: #ff9275;
        }
      }
    }
  }
}
.black-theme{
  .address-prove{
    .title{
      color: #fff;
      border-color: rgba(50,52,66,.5);
    }
    .sub-title-box{
      color: #fff;
    }
    .ipt-box{
      &.focus{
        .ipt-main{
          &:after{
            border-color: rgba(255,255,255,1);
          }
        }
      }
      &.error{
        .ipt-main{
          &:after{
            border-color: #fd2626;
          }
        }
      }
      .ipt-main{
        &:after{
          border-color: rgba(255,255,255,0.25);
        }
        .label{
          color: #9D9D9F;
        }
        .icon-arrow{
          background: url("../../../assets/images/open-account/dark_icon.png") no-repeat;
          width: 32px;
          height: 32px;
          background-size: 100% 100%;
        }
        .val{
          color: #fff;
          ::v-deep{
            .van-cell__value input::placeholder {
              color: #9D9D9F !important;
            }
            textarea{
              color: #fff;
            }
          }
        }
      }
    }
  }
}

.check-country {
  width: 100%;
  height: 100vh;
  border-radius: 0;
  z-index: 9999 !important;
  display: flex;
  flex-direction: column;
  .dialog-head {
    height: 100px;
    display: flex;
    padding: 0 100px;
    position: relative;
    .btn-back {
      position: absolute;
      left: 0;
      top: 0;
      height: 100px;
      width: 100px;
      background: url("../../../assets/images/arrow-right.png") no-repeat center;
      background-size: 48px 48px;
      transform: rotateY(180deg);
    }
    .dialog-title {
      flex: 1;
      text-align: center;
      font-size: 32px;
      color: #17161c;
      line-height: 100px;
    }
  }
  .input-box {
    padding: 0 32px;
    ::v-deep .van-cell {
      border-radius: 75px;
      background: #f7f8fa;
      min-height: 75px;
    }
  }
  .list {
    margin-top: 20px;
    flex: 1;
    position: relative;
    .list-main {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow-y: scroll;
      .item {
        line-height: 80px;
        padding: 0 32px;
        border-bottom: 1px solid rgba(23, 22, 28, 0.1);
        font-size: 28px;
        color: #323233;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.cur {
          color: #ff9275;
        }
      }
    }
  }
}
</style>
